import { call, put } from 'redux-saga/effects'
import {
  fetchInterviewRequestInterviewEvents,
  createInterviewRequestInterviewEvent,
  patchInterviewRequestInterviewEvent,
} from '../apiModules/interviewRequestEvents'
import { interviewRequestEventEntities } from '../reducks'

export function* fetchInterviewRequestInterviewEventEntitiesSaga(interviewRequestId, sortBy, sortDirection, interviewSource) {
  const response = yield call(fetchInterviewRequestInterviewEvents, interviewRequestId, sortBy, sortDirection, interviewSource)

  yield put(interviewRequestEventEntities.addCollection(response))
  return response
}

export function* createInterviewRequestInterviewEventEntitySaga(input) {
  const response = yield call(createInterviewRequestInterviewEvent, input)

  yield put(interviewRequestEventEntities.addItem(response.interviewEvent.id, response.interviewEvent))

  return response.interviewEvent
}

export function* updateInterviewRequestInterviewEventEntitySaga(interviewRequestId, interviewEventId, data) {
  const response = yield call(patchInterviewRequestInterviewEvent, interviewRequestId, interviewEventId, data)
  yield put(interviewRequestEventEntities.updateItem(interviewEventId, response.result))
  return response
}
